// 👇 id es interno, `code` es el real que entiende la impresora
export const codePageOptions = [
  { id: 0,  name: 'PC437 (Std. Europe)', code: 'PC437' },
  { id: 1,  name: 'Katakana', code: 'KATAKANA' },
  { id: 2,  name: 'PC850 (Multilingual)', code: 'PC850' },
  { id: 3,  name: 'PC860 (Portugal)', code: 'PC860' },
  { id: 4,  name: 'PC863 (Canadian)', code: 'PC863' },
  { id: 5,  name: 'PC865 (Nordic)', code: 'PC865' },
  { id: 6,  name: 'Greek', code: 'GREEK' },
  { id: 7,  name: 'Hebrew', code: 'HEBREW' },
  { id: 8,  name: 'East Europe', code: 'EAST_EUROPE' },
  { id: 9,  name: 'Iran', code: 'IRAN' },

  { id: 16, name: 'WPC1252 (Latin1 Windows)', code: 'WPC1252' },
  { id: 17, name: 'PC858 (Latin1+Euro)', code: 'PC858' },
  { id: 18, name: 'PC852 (Latin2)', code: 'PC852' },
  { id: 19, name: 'IranII', code: 'IRANII' },
  { id: 21, name: 'Latvian', code: 'LATVIAN' },
  { id: 22, name: 'Arabic', code: 'ARABIC' },
  { id: 23, name: 'PT1511251 (Portuguese)', code: 'PT1511251' },
  { id: 24, name: 'PC747', code: 'PC747' },

  { id: 27, name: 'Vietnam', code: 'VIETNAM' },
  { id: 28, name: 'PC1001 (Arabic)', code: 'PC1001' },
  { id: 29, name: 'Uigur', code: 'UIGUR' },
  { id: 30, name: 'Hebrew', code: 'HEBREW' },
  { id: 31, name: 'Hebrew', code: 'HEBREW' },
  { id: 32, name: 'WPC1255 (Israel)', code: 'WPC1255' },
  { id: 33, name: 'WPC1256 (Arabic)', code: 'WPC1256' },

  { id: 50, name: 'PC437 (Std. Europe)', code: 'PC437' },
  { id: 52, name: 'PC852 (Latin2)', code: 'PC852' },
  { id: 53, name: 'PC858 (Multilingual)', code: 'PC858' },
  { id: 55, name: 'PC860 (Portugal)', code: 'PC860' },
  { id: 66, name: 'PC737 (Greek)', code: 'PC737' },
  { id: 68, name: 'PC772 (Lithuanian)', code: 'PC772' },
  { id: 70, name: 'PC874 (Thai)', code: 'PC874' },
  { id: 72, name: 'WPC1250 (Latin-2)', code: 'WPC1250' },
  { id: 74, name: 'PC3840 (IBM-Russian)', code: 'PC3840' },
  { id: 78, name: 'PC3843 (Polish)', code: 'PC3843' },
  { id: 79, name: 'PC3846 (Turkish)', code: 'PC3846' },
  { id: 80, name: 'PC3847 (Brazil-ABNT)', code: 'PC3847' },
  { id: 81, name: 'PC3848 (Brazil)', code: 'PC3848' },
  { id: 82, name: 'PC1001 (Arabic)', code: 'PC1001' },
  { id: 83, name: 'PC2001 (Lithuanian)', code: 'PC2001' },
  { id: 85, name: 'PC3002 (Estonian-2)', code: 'PC3002' },
  { id: 86, name: 'PC3011 (Latvian-1)', code: 'PC3011' },
  { id: 87, name: 'PC3012 (Latv-2)', code: 'PC3012' },
  { id: 88, name: 'PC3021 (Bulgarian)', code: 'PC3021' },
  { id: 89, name: 'PC3041 (Maltese)', code: 'PC3041' },
];
